/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetChatLogsThreadResponse,
  PaginatedThreadsResponse,
} from '../models/index';
import {
    GetChatLogsThreadResponseFromJSON,
    GetChatLogsThreadResponseToJSON,
    PaginatedThreadsResponseFromJSON,
    PaginatedThreadsResponseToJSON,
} from '../models/index';

export interface ChatLogsControllerAllLogsRequest {
    userId: string;
    threadId: string;
}

export interface ChatLogsControllerLogStreamRequest {
    userId: string;
    threadId: string;
}

export interface ChatLogsControllerThreadsRequest {
    userId: string;
    orphans: boolean;
    page?: number;
    limit?: number;
    sortBy?: ChatLogsControllerThreadsSortByEnum;
    sortOrder?: ChatLogsControllerThreadsSortOrderEnum;
}

/**
 * ChatLogsApi - interface
 * 
 * @export
 * @interface ChatLogsApiInterface
 */
export interface ChatLogsApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatLogsApiInterface
     */
    chatLogsControllerAllLogsRaw(requestParameters: ChatLogsControllerAllLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChatLogsThreadResponse>>;

    /**
     */
    chatLogsControllerAllLogs(requestParameters: ChatLogsControllerAllLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChatLogsThreadResponse>;

    /**
     * 
     * @param {string} userId 
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatLogsApiInterface
     */
    chatLogsControllerLogStreamRaw(requestParameters: ChatLogsControllerLogStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    chatLogsControllerLogStream(requestParameters: ChatLogsControllerLogStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {boolean} orphans 
     * @param {number} [page] Page to fetch data from
     * @param {number} [limit] Maximum amount of items to be returned per page
     * @param {'createdAt' | 'title'} [sortBy] Field to sort by
     * @param {'ASC' | 'DESC'} [sortOrder] Sort order of the results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatLogsApiInterface
     */
    chatLogsControllerThreadsRaw(requestParameters: ChatLogsControllerThreadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedThreadsResponse>>;

    /**
     */
    chatLogsControllerThreads(requestParameters: ChatLogsControllerThreadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedThreadsResponse>;

}

/**
 * 
 */
export class ChatLogsApi extends runtime.BaseAPI implements ChatLogsApiInterface {

    /**
     */
    async chatLogsControllerAllLogsRaw(requestParameters: ChatLogsControllerAllLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChatLogsThreadResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling chatLogsControllerAllLogs().'
            );
        }

        if (requestParameters['threadId'] == null) {
            throw new runtime.RequiredError(
                'threadId',
                'Required parameter "threadId" was null or undefined when calling chatLogsControllerAllLogs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat-logs/{userId}/{threadId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"threadId"}}`, encodeURIComponent(String(requestParameters['threadId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetChatLogsThreadResponseFromJSON(jsonValue));
    }

    /**
     */
    async chatLogsControllerAllLogs(requestParameters: ChatLogsControllerAllLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChatLogsThreadResponse> {
        const response = await this.chatLogsControllerAllLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async chatLogsControllerLogStreamRaw(requestParameters: ChatLogsControllerLogStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling chatLogsControllerLogStream().'
            );
        }

        if (requestParameters['threadId'] == null) {
            throw new runtime.RequiredError(
                'threadId',
                'Required parameter "threadId" was null or undefined when calling chatLogsControllerLogStream().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat-logs/{userId}/{threadId}/stream`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"threadId"}}`, encodeURIComponent(String(requestParameters['threadId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async chatLogsControllerLogStream(requestParameters: ChatLogsControllerLogStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chatLogsControllerLogStreamRaw(requestParameters, initOverrides);
    }

    /**
     */
    async chatLogsControllerThreadsRaw(requestParameters: ChatLogsControllerThreadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedThreadsResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling chatLogsControllerThreads().'
            );
        }

        if (requestParameters['orphans'] == null) {
            throw new runtime.RequiredError(
                'orphans',
                'Required parameter "orphans" was null or undefined when calling chatLogsControllerThreads().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orphans'] != null) {
            queryParameters['orphans'] = requestParameters['orphans'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat-logs/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedThreadsResponseFromJSON(jsonValue));
    }

    /**
     */
    async chatLogsControllerThreads(requestParameters: ChatLogsControllerThreadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedThreadsResponse> {
        const response = await this.chatLogsControllerThreadsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ChatLogsControllerThreadsSortByEnum = {
    CreatedAt: 'createdAt',
    Title: 'title'
} as const;
export type ChatLogsControllerThreadsSortByEnum = typeof ChatLogsControllerThreadsSortByEnum[keyof typeof ChatLogsControllerThreadsSortByEnum];
/**
 * @export
 */
export const ChatLogsControllerThreadsSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type ChatLogsControllerThreadsSortOrderEnum = typeof ChatLogsControllerThreadsSortOrderEnum[keyof typeof ChatLogsControllerThreadsSortOrderEnum];
